<div class="container mt-4">
  <!-- KPI Cards -->
  <div class="row text-center">
    <div class="col-md-3">
      <div class="card p-3 shadow">
        <h5>Total Orders</h5>
        <h3>{{ kpi.totalOrders }}</h3>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card p-3 shadow">
        <h5>Completed Orders Value</h5>
        <h3>₹{{ formatIndian(kpi.totalRevenue) }}</h3>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card p-3 shadow">
        <h5>Pending Orders</h5>
        <h3>{{ kpi.pendingOrders }}</h3>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card p-3 shadow">
        <h5>Pending Orders Value</h5>
        <h3>₹{{ formatIndian(kpi.pendingRevenue) }}</h3>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="row mt-4">
    <!-- Daily Sales -->
    <div class="col-md-6">
      <div class="card p-3 shadow">
        <div class="d-flex justify-content-between">
          <h5>Daily Sales</h5>
          <a
            href="/orders/listing"
            class=""
            style="text-decoration: none !important"
            >See All Orders</a
          >
        </div>
        <canvas
          baseChart
          [data]="dailySalesData"
          chartType="line"
          [type]="'line'"
          [options]="chartOptionsLine"
        >
        </canvas>
      </div>
    </div>

    <!-- Monthly Sales -->
    <div class="col-md-6">
      <div class="card p-3 shadow">
        <h5>Monthly Sales</h5>
        <canvas
          baseChart
          [data]="monthlySalesData"
          chartType="bar"
          [options]="chartOptionsBar"
        >
        </canvas>
      </div>
    </div>
  </div>

  <!-- Commission Charts -->
  <div class="row mt-4">
    <!-- Commission Count -->
    <div class="col-md-6">
      <div class="card p-3 shadow">
        <div class="d-flex justify-content-between">
          <h5>Commission Count by Status</h5>
          <a
            href="/commission"
            class=""
            style="text-decoration: none !important"
            >See Commission Details</a
          >
        </div>
        <canvas
          baseChart
          [data]="commissionCountPie"
          chartType="pie"
          [type]="'pie'"
          [options]="chartOptionsPie"
        >
        </canvas>
      </div>
    </div>

    <!-- Commission Amount -->
    <div class="col-md-6">
      <div class="card p-3 shadow">
        <h5>Commission Amount by Status</h5>
        <canvas
          baseChart
          [data]="commissionAmountPie"
          chartType="doughnut"
          [type]="'doughnut'"
          [options]="chartOptions"
        >
        </canvas>
      </div>
    </div>
  </div>
</div>
